export default "__VITE_ASSET__Cb7t4C7u__"